// src/client.ts
import { feathers } from "@feathersjs/feathers";
import authenticationClient from "@feathersjs/authentication-client";

// src/services/issuable-item-category/issuable-item-category.shared.ts
var issuableItemCategoryPath = "/user/v1/:tenantId/issuableItemCategory";
var issuableItemCategoryMethods = ["find", "get", "create", "patch", "remove"];
var issuableItemCategoryClient = (client) => {
  const connection = client.get("connection");
  client.use(issuableItemCategoryPath, connection.service(issuableItemCategoryPath), {
    methods: issuableItemCategoryMethods
  });
};

// src/services/issuable/issuable.shared.ts
var issuablePath = "/user/v1/:tenantId/issuable";
var issuableMethods = ["find", "get", "create", "patch", "remove", "reserveCardForVisitor"];
var issuableClient = (client) => {
  const connection = client.get("connection");
  client.use(issuablePath, connection.service(issuablePath), {
    methods: issuableMethods
  });
};

// src/services/nationality/nationality.shared.ts
var nationalityPath = "/user/v1/:tenantId/nationality";
var nationalityMethods = ["find", "get"];
var nationalityClient = (client) => {
  const connection = client.get("connection");
  client.use(nationalityPath, connection.service(nationalityPath), {
    methods: nationalityMethods
  });
};

// src/services/user-photo/user-photo.shared.ts
var userPhotoPath = "/user/v1/:tenantId/user-photo";
var userPhotoMethods = ["find", "get", "update", "remove"];
var userPhotoClient = (client) => {
  const connection = client.get("connection");
  client.use(userPhotoPath, connection.service(userPhotoPath), {
    methods: userPhotoMethods
  });
};

// src/services/phone-type/phone-type.shared.ts
var phoneTypePath = "/user/v1/:tenantId/phone-type";
var phoneTypeMethods = ["find", "get"];
var phoneTypeClient = (client) => {
  const connection = client.get("connection");
  client.use(phoneTypePath, connection.service(phoneTypePath), {
    methods: phoneTypeMethods
  });
};

// src/services/user-special-assistance-need/user-special-assistance-need.shared.ts
var userSpecialAssistanceNeedPath = "/user/v1/:tenantId/special-assistance-need";
var userSpecialAssistanceNeedMethods = [
  "find",
  "get",
  "create",
  "patch",
  "remove"
];
var userSpecialAssistanceNeedClient = (client) => {
  const connection = client.get("connection");
  client.use(userSpecialAssistanceNeedPath, connection.service(userSpecialAssistanceNeedPath), {
    methods: userSpecialAssistanceNeedMethods
  });
};

// src/services/user-announce-protocol/user-announce-protocol.shared.ts
var userAnnounceProtocolPath = "/user/v1/:tenantId/announce-protocol";
var userAnnounceProtocolMethods = [
  "find",
  "get",
  "create",
  "patch",
  "remove"
];
var userAnnounceProtocolClient = (client) => {
  const connection = client.get("connection");
  client.use(userAnnounceProtocolPath, connection.service(userAnnounceProtocolPath), {
    methods: userAnnounceProtocolMethods
  });
};

// src/services/title/title.shared.ts
var titlePath = "/user/v1/:tenantId/title";
var titleMethods = ["find", "get"];
var titleClient = (client) => {
  const connection = client.get("connection");
  client.use(titlePath, connection.service(titlePath), {
    methods: titleMethods
  });
};

// src/services/note-type/note-type.shared.ts
var noteTypesPath = "/user/v1/:tenantId/note-type";
var noteTypesMethods = ["find", "get", "create", "patch", "remove"];
var noteTypesClient = (client) => {
  const connection = client.get("connection");
  client.use(noteTypesPath, connection.service(noteTypesPath), {
    methods: noteTypesMethods
  });
};

// src/services/user-field/user-field.shared.ts
var userFieldsPath = "/user/v1/:tenantId/user-field";
var userFieldsMethods = ["find", "get"];
var userFieldsClient = (client) => {
  const connection = client.get("connection");
  client.use(userFieldsPath, connection.service(userFieldsPath), {
    methods: userFieldsMethods
  });
};

// src/services/user/user.shared.ts
var usersPath = "/user/v1/:tenantId";
var usersMethods = ["find", "get", "create", "patch", "remove", "update", "toggleSimpleBooking"];
var userClient = (client) => {
  const connection = client.get("connection");
  client.use(usersPath, connection.service(usersPath), {
    methods: usersMethods
  });
};

// src/client.ts
var createClient = (connection, authenticationOptions = {}) => {
  const client = feathers();
  client.configure(connection);
  client.configure(authenticationClient(authenticationOptions));
  client.set("connection", connection);
  client.configure(userClient);
  client.configure(userFieldsClient);
  client.configure(noteTypesClient);
  client.configure(titleClient);
  client.configure(userAnnounceProtocolClient);
  client.configure(userSpecialAssistanceNeedClient);
  client.configure(phoneTypeClient);
  client.configure(userPhotoClient);
  client.configure(nationalityClient);
  client.configure(issuableClient);
  client.configure(issuableItemCategoryClient);
  return client;
};
export {
  createClient
};
//# sourceMappingURL=client.js.map